<template>
  <div>
    <div class="form-card">
      <h3 class="form-card-title">
        <span class="title-text">{{ $t('labels.acc.mobile.verf') }}</span>
        <!-- <span class="explain">
          <i class="star">*</i>
          手机绑定后不可更换
        </span>-->
      </h3>
      <ValidationObserver ref="validate">
        <div class="form-card-body">
          <div class="form-group">
            <p class="color-error mb-10" v-if="Getter_User_Info.gaStatus == 0">
              {{ $t('labels.acc.ga.txt.1') }}
              <router-link to="/usercenter/google-verification-bind" class="text-bold color-error">
                {{ $t('labels.acc.ga.setup') }}
              </router-link>
            </p>
          </div>

          <div class="form-group">
            <ValidationProvider :name="$t('labels.mobileNo')" :rules="rules.mobileNo" v-slot="{ errors }">
              <vue-tel-input
                tabindex="4"
                inputClasses="tel-input"
                class="form-control form-input"
                style="z-index: 100"
                v-model="form.displayPhone"
                @input="onInputPhone"
                :placeholder="$t('labels.mobileNo')"
                required
                @validate="validatePhone"
              ></vue-tel-input>

              <div class="d-flex align-center error-msg mt-1 mb-2" style="min-height: 18px">
                <div v-if="errors[0] || !phoneValid">
                  <span v-if="errors[0]">{{ errorMsgs.displayPhone.required }}</span>
                  <span v-else>{{ errorMsgs.mobile.phoneValid }}</span>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <div class="d-flex verify-wrap">
              <TextFieldComponent
                class="flex-fill otp-textField"
                :model.sync="form.otp"
                :label="$t('labels.otp')"
                :outlined="true"
                :rules="rules.otp"
              ></TextFieldComponent>
              <VerifyBtn
                class="mt-0"
                type="phone"
                :value="form.mobile"
                :country-code="form.phoneCode"
                :onProgressText="$t('common.verifyCount')"
                :condition="sendPhoneValidCondition"
              ></VerifyBtn>
            </div>
          </div>
          <div class="form-group">
            <v-btn class="commit-btn" depressed :loading="committing ? true : false" @click="submitBtnClick">{{
              0 == Getter_User_Info.mobileStatus ? $t('labels.acc.bindNow') : $t('labels.acc.unbindNow')
            }}</v-btn>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import index from './phone-bind';

export default index;
</script>

<style src="@/common/styles/mixin/account-bind.scoped.styl" lang="stylus" scoped></style>
<style lang="stylus" scoped>
@import 'phone-bind.scoped.styl';
</style>
